import { render, staticRenderFns } from "./RecollectionManagement.vue?vue&type=template&id=2908fd14&scoped=true"
import script from "./RecollectionManagement.vue?vue&type=script&lang=js"
export * from "./RecollectionManagement.vue?vue&type=script&lang=js"
import style0 from "./RecollectionManagement.vue?vue&type=style&index=0&id=2908fd14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908fd14",
  null
  
)

export default component.exports